document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".quickview-btn"); // Adjust if your button class is different
  if (!btn) return;

  e.preventDefault();

  // Get product handle from the button
  const handle = btn.dataset.handle;
  if (!handle) return console.warn("No product handle found for Quick View");

  // Show loader (optional)
  const loader = document.querySelector("#loading_qv");
  if (loader) loader.style.opacity = "1";

  try {
    // Fetch product JSON
    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) throw new Error("Failed to load product data");
    const product = await response.json();
    const variant = product.variants[0];

    // ---- Fill Product Info ----
    const title = document.querySelector(".qv-product-title");
    const vendor = document.querySelector(".product-single__vendor small:last-child");
    const type = document.querySelector(".product-single__type small:last-child");
    const sku = document.querySelector(".js-variant-sku");
    const availability = document.querySelector(".product-single__availability small:last-child");
    const price = document.querySelector(".qv-product-price");

    if (title) title.textContent = product.title;
if (vendor) {
  if (product.vendor) {
    const brandLink = `/collections/vendors?q=${encodeURIComponent(product.vendor)}`;
    vendor.innerHTML = `<a href="${brandLink}" class="vendor-link">${product.vendor}</a>`;
  } else {
    vendor.textContent = "N/A";
  }
};
    if (type) type.textContent = product.type || "N/A";
    if (sku) sku.textContent = variant.sku || "N/A";
    if (availability) availability.textContent = variant.available ? "Available" : "Sold Out";

    if (price) {
      const formatted = (variant.price / 100).toLocaleString(undefined, {
        style: "currency",
        currency: Shopify.currency.active || "USD"
      });
      price.textContent = formatted;
    }

    // ---- Optional: Product Link ----
    const fullLink = document.querySelector(".qv-view-product");
    if (fullLink) fullLink.setAttribute("href", product.url || `/products/${product.handle}`);

    // ---- Optional: Update Images ----
    const imgContainer = document.querySelector("#qv-product-images");
    if (imgContainer) {
      imgContainer.innerHTML = "";
      product.images.forEach((imgSrc) => {
        const img = document.createElement("img");
        img.src = imgSrc;
        img.className = "img-fluid mb-2";
        imgContainer.appendChild(img);
      });
      imgContainer.style.opacity = "1";
    }

    // Hide loader
    if (loader) loader.style.opacity = "0";

    // Open modal (if using Bootstrap)
    const modal = document.querySelector("#jsQuickview");
    if (modal) {
      const bsModal = new bootstrap.Modal(modal);
      bsModal.show();
    }

  } catch (err) {
    console.error("Quick View error:", err);
    if (loader) loader.style.opacity = "0";
  }
});



